export function VendorCreditsCtrl ($scope, $translate, workshopAPI) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'vendor_invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe  : 'globalDate'
      },
      {
        field : 'total',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe  : 'globalCurrency'
      },
      {
        field : 'availableCredit',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.AVAILABLE_CREDIT')
        },
        pipe  : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('GENERAL_SPACE.FIELD.NO_CREDITS_AVAILABLE')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendors/invoice_count', [
        $scope.vendor.id,
        'P', 'C', '*', '*', '*'
      ])
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.calculateAvailableCredit = function (credits) {
    angular.forEach(credits, function (credit) {
      var total = new BigDecimal(credit.total ? credit.total.toString(): '0').setScale(2, BigDecimal.ROUND_HALF_UP);
      var usedCredit = new BigDecimal(credit.applied_credit_amount ? credit.applied_credit_amount.toString(): '0').setScale(2, BigDecimal.ROUND_HALF_UP);

      credit.availableCredit = total.subtract(usedCredit).toString();
    });

    return credits;
  };
  
  $scope.getCredits = ( params ) => {
    return workshopAPI.get('/vendors/invoice_list', [
      $scope.vendor.id,
      params.offset,
      params.pageSize,
      'P',
      'C',
      '*',
      '*',
      '*',
      params.field,
      params.direction
    ]).then(function (credits) {
      $scope.credits = $scope.calculateAvailableCredit(credits);
      return $scope.credits
    });
  };

  $scope.calculateAvailableCredit($scope.credits);
}